const principles = [
  {
    icon: "ri-file-search-line",
    title: "先核实，再动笔",
    desc: "任何一条信息在成稿前都要找到至少一处可公开追溯的来源，找不到就先不写，或者明确标注为未经核实。",
  },
  {
    icon: "ri-scales-3-line",
    title: "呈现双方说法",
    desc: "涉及争议的话题，我们会尽量同步呈现相关内容方的公开回应，不替任何一方下判断，也不做道德裁决。",
  },
  {
    icon: "ri-edit-2-line",
    title: "错了就改，改了就标",
    desc: "内容出现偏差时，我们直接修订原文并在页面底部保留更正说明，不做悄悄删改。",
  },
  {
    icon: "ri-user-heart-line",
    title: "不拿隐私当卖点",
    desc: "不发布与公共话题无关的私人信息，不追逐未经同意的私人影像，这也是我们最常拒绝的一类内容。",
  },
];

export default function PrincipleSection() {
  return (
    <section id="principle" className="scroll-mt-32">
      <div className="mb-8">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-shield-star-line text-[11px]"></i>
          </span>
          内容原则
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          四条我们一直守着的规矩
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
          这些原则写下来很简单，难的是每天执行。如果你发现我们哪一次没做到，欢迎直接指出来。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {principles.map((item, index) => (
          <div
            key={item.title}
            className="flex gap-4 rounded-card border border-background-200/80 bg-background-50 p-5 transition-colors duration-200 hover:border-primary-200"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-heading text-xs font-black text-foreground-300">
                  0{index + 1}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}